import { t } from '../localization/adminText';

export function riskImportError(error) {
  const body = error?.response?.data || {};
  return Object.values(body.errors || body.data?.errors || {}).flat()[0]
    || body.message || body.msg || error?.message || 'Request failed.';
}

export function riskImportTime(row, systemTimezone, accepted = false) {
  const value = accepted ? row.accepted_at : row.occurred_at;
  const precision = accepted ? 'second' : row.date_precision;
  if (!value || !['day', 'second'].includes(precision)) return '—';
  const zone = precision === 'day' ? row.source_timezone : systemTimezone;
  if (!zone) return '—';
  try {
    let date;
    if (precision === 'day' && /^\d{4}-\d{2}-\d{2}$/.test(row.source_datetime_raw || '')) {
      date = row.source_datetime_raw;
    } else {
      if (typeof value !== 'string' || !/(Z|[+-]\d{2}:\d{2})$/.test(value)) return '—';
      const options = { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' };
      if (precision === 'second') Object.assign(options, { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', options).formatToParts(new Date(value)).map(part => [part.type, part.value]));
      date = `${parts.year}-${parts.month}-${parts.day}`;
      if (precision === 'second') return `${date} ${parts.hour}:${parts.minute}:${parts.second}`;
    }
    return t('{0} (date only, {1})', [date, zone]);
  } catch { return '—'; }
}

export function riskOutcomeLabel(outcome) {
  const labels = { delivered: 'Delivered', refused: 'Refused', unreceived: 'Unreceived', returned: 'Returned', in_transit: 'In transit', unknown: 'Unknown' };
  return t(labels[outcome] || 'Unknown');
}

export function sharedReviewLabel(record) {
  if (record.shared_active) return t('Shared');
  return record.review_status === 'pending' ? t('Pending shared review') : t('Not shared');
}

export function riskRowStatus(status) {
  const labels = { ready: 'Ready', invalid: 'Invalid', duplicate: 'Duplicate', stale: 'Outdated', conflict: 'Conflict' };
  return t(labels[status] || 'Unknown');
}

export function downloadRiskTemplate(data) {
  const url = URL.createObjectURL(new Blob([data.content], { type: `${data.mime_type || 'text/csv'};charset=utf-8` }));
  const anchor = document.createElement('a');
  anchor.href = url; anchor.download = data.filename;
  document.body.appendChild(anchor); anchor.click(); anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function readRiskFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('Could not read the file.'));
    reader.readAsDataURL(file);
  });
}
